import React from 'react';
import './Button.css';

interface ButtonProps {
  value: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'third';
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  icon?: React.ReactNode; // New prop for SVG icon
}

const Button: React.FC<ButtonProps> = ({
  value,
  variant = 'primary',
  size = 'medium',
  onClick,
  disabled = false,
  type = 'button',
  className = '',
  icon,
}) => {
  return (
    <button
      className={`button ${variant} ${size} ${className}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {icon && <span className="button-icon">{icon}</span>}
      {value}
    </button>
  );
};

export default Button;